export default "__VITE_ASSET__CnJVS8C0__"